import {
  CharacteristicsItemWrapper,
  CharacteristicsKey,
  CharacteristicsValueInput,
  CharacteristicsWrapper,
  CharacteristicsUnit,
} from './styles';

const CharacteristicsEdit = ({ characteristics, onChange }) => {
  if (!characteristics || Object.keys(characteristics).length < 1) {
    return <CharacteristicsWrapper />;
  }

  let characteristicKeys = Object.keys(characteristics);

  return (
    <CharacteristicsWrapper>
      {characteristics &&
        characteristicKeys.map((characteristicKey) => (
          <CharacteristicsItemWrapper key={characteristicKey}>
            <CharacteristicsKey>{`${characteristics[characteristicKey].name}:`}</CharacteristicsKey>
            <CharacteristicsValueInput
              value={characteristics[characteristicKey].value}
              name={characteristicKey} // name required to find the key in the event on change
              onChange={onChange}
            />
            <CharacteristicsUnit>{characteristics[characteristicKey].unit}</CharacteristicsUnit>
          </CharacteristicsItemWrapper>
        ))}
    </CharacteristicsWrapper>
  );
};

export default CharacteristicsEdit;
